import React, { useState, useEffect } from "react";

import belfor1 from "../../assets/belfor_1.jpg";
import belfor2 from "../../assets/belfor_2.png";

const CDN_BASE_URL = "https://storage.googleapis.com/wacofirefightersbenefit";

const Partners = () => {
    const [partners, setPartners] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPartners = async () => {
            try {
                // Add timestamp to bypass cache
                const response = await fetch(`${CDN_BASE_URL}/data/partners.json`);
                if (!response.ok) {
                    throw new Error('Failed to fetch partners');
                }
                const data = await response.json();
                // Sort partners: preferred first
                const sortedData = data.sort((a, b) => {
                    if (a.preferred === b.preferred) return 0;
                    return a.preferred ? -1 : 1;
                });
                setPartners(sortedData);
            } catch (error) {
                console.error('Error fetching partners:', error);
                // Fallback to empty or could load a local backup if needed
            } finally {
                setLoading(false);
            }
        };

        fetchPartners();
    }, []);

    return (
        <div className="p-[20px] text-center max-w-[60ch] mx-auto">
            <h1 className="text-[4em] mb-[10px] max-md:text-[2em]">Our Partners</h1>
            <p className="text-[1.5em] mb-[20px] max-md:text-[1em]">Your generosity is transforming lives. Thank you for your invaluable contribution!</p>
            <div className="text-[12pt] m-[20px] bg-[#f5f5fc] border-[1px] border-gray-300 p-[20px] rounded-[15px]">
                <h1 className="text-2xl font-bold mb-4">Special Thanks</h1>
                <div style={{ display: 'flex', gap: '20px', flexDirection: 'column', alignItems: 'center' }}>
                    <img src={belfor1} width={200} style={{ borderRadius: '20px' }} alt="Belfor" />
                    <img src={belfor2} width={200} style={{ borderRadius: '20px' }} alt="Belfor" />

                </div>
                <p className="text-justify">Special thanks to Sheldon Yellen, CEO of BELFOR Holdings, Inc., for his generous contribution of scholarships to the Waco Firefighter Benefit Association.
                    <br /><br />
                    Your support is making a significant impact on the lives of our members and their families, helping them achieve their educational aspirations. Your dedication to our community is truly inspiring and deeply appreciated.
                </p>
            </div>
            <div className="flex flex-wrap justify-center gap-4 my-8">
                <h1 className="text-3xl font-bold mb-2 w-full">Selected Partners</h1>
                <p className="text-xl mb-4 w-full">Thank you to our generous partners for your support!</p>
                {loading ? (
                    <p></p>
                ) : (
                    <div className="flex flex-wrap justify-center gap-4 my-8">
                        <div className="flex flex-wrap justify-center gap-4 my-8">
                            {partners
                                .filter(partner => partner.preferred)
                                .map((partner) => (
                                    <React.Fragment key={partner.id}>
                                        <div className="flex flex-col items-center justify-center w-[200px] h-[200px] rounded-[5px]">
                                            {partner.website ? (
                                                <a href={partner.website} target="_blank" rel="noopener noreferrer">
                                                    <img
                                                        src={`${CDN_BASE_URL}/${partner.image}`}
                                                        alt={partner.name}
                                                        title={partner.name}
                                                    />
                                                </a>
                                            ) : (
                                                <img
                                                    src={`${CDN_BASE_URL}/${partner.image}`}
                                                    alt={partner.name}
                                                    title={partner.name}
                                                />
                                            )}
                                        </div>
                                    </React.Fragment>
                                ))}
                        </div>
                        <p className="text-2xl font-bold mb-2 w-full">All Partners</p>
                        <div className="flex flex-wrap justify-center gap-4 my-8">
                            {partners
                                .filter(partner => !partner.preferred)
                                .map((partner) => (
                                    <React.Fragment key={partner.id}>
                                        <div className="flex flex-col items-center justify-center w-[100px] h-[100px] rounded-[5px]">
                                            {partner.website ? (
                                                <a href={partner.website} target="_blank" rel="noopener noreferrer">
                                                    <img
                                                        src={`${CDN_BASE_URL}/${partner.image}`}
                                                        alt={partner.name}
                                                        title={partner.name}
                                                    />
                                                </a>
                                            ) : (
                                                <img
                                                    src={`${CDN_BASE_URL}/${partner.image}`}
                                                    alt={partner.name}
                                                    title={partner.name}
                                                />
                                            )}
                                        </div>
                                    </React.Fragment>
                                ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Partners;

